export var ViewModeItem;
(function (ViewModeItem) {
    ViewModeItem["Edititng"] = "editing";
    ViewModeItem["Desktop"] = "desktop";
    ViewModeItem["Tablet"] = "tablet";
    ViewModeItem["Mobile"] = "mobile";
})(ViewModeItem || (ViewModeItem = {}));
export var FormTab;
(function (FormTab) {
    FormTab["Blocks"] = "blocks";
    FormTab["Page"] = "page";
    FormTab["Code"] = "code";
})(FormTab || (FormTab = {}));
